<template>
    <div class='msgCenter'>
        <div class='msgTitle'>
            <p class='lf'>消息中心</p>
            <p class='rt' @click='moreMsg'>更多 +</p>
        </div>
        <div class='msgs'>
            <div class='xtMsg'>
                <h3>系统提示 <span>{{xtMsgTime}}</span></h3>
                <!-- <span class='activeStep'>当前阶段：<span>{{activeStep}}</span></p> -->
                <div>{{activeStepMsg}}</div>
                <!-- <span class='nextStep'>下一阶段：<span>{{nextStep?nextStep:'无'}}</span></p> -->
            </div>
            <div class='msg' id='msg'>
                <div v-for='(item,index) in sokctMsg' :key='index'>
                    <span class='dwmc'>{{item.mc}}</span>{{item.msg}}
                </div>
            </div>
            <p class='closeMsg' @click='close' v-if='role=="Z"'>
                <template v-if='!flag'>关闭</template>
                <template v-else>开启</template>
                发言
            </p>
        </div>
        <div class='msgText'>
            <el-input v-model="msg" :disabled="flag&&role=='B'" @keyup.enter.native="send"></el-input>
            <el-button type="primary" @click='send' :disabled="flag&&role=='B'">发言</el-button>
        </div>
        <!-- 更多消息 -->
        <el-dialog title="消息中心" :visible.sync="xxzxDialog" width='900px' lock-scroll :close-on-click-modal="false">
            <el-table :data="xxzxList" border >
                <el-table-column property="index" label="序号" width="50">
                    <template slot-scope="scope">{{scope.$index + 1}}</template>
                </el-table-column>
                <el-table-column property="sj" label="时间" width="160" :formatter="sjFormatter"></el-table-column>
                <el-table-column property="dqjd" label="当前阶段" width="130"></el-table-column>
                <el-table-column property="xxnr" label="消息内容" min-width='350' show-overflow-tooltip></el-table-column>
                <el-table-column property="xyjd" label="下一阶段" width='130'></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name:'msg',
    data(){
        return{
            xtMsgTime:'',
            activeStep:'',
            activeStepMsg:'',
            nextStep:'',
            path:(location.protocol === 'http:' ? 'ws' : 'wss') + '://'+window.location.host+'/api/v2/websocket?bdId='+this.bdId,
            websock:'',
            msg:'',
            sokctMsg:[],
            flag:false,
            xxzxDialog:false,//消息中心弹窗
            xxzxList:[],
            bdId:localStorage.getItem('bdId')?localStorage.getItem('bdId'):'',
            sfkqsxt: false
        }
    },
    computed:{
        role(){
            return localStorage.getItem('role')?localStorage.getItem('role'):'T';
        },
    },
    methods:{
        getMsg(){
            let para={}
            this.$api.getMsg(para).then(res=>{
                if(res.data.meta.success){
                    console.log('msgh',res);
                    this.flag=res.data.data.kbxm.kqfy=='1'?false:true;
                    this.xtMsgTime=res.data.data.time;
                    this.activeStep=res.data.data.jxzKbxmlc;
                    this.activeStepMsg=res.data.data.jxzTsnr;
                    this.nextStep=res.data.data.nextKbxmlc;
                    this.sokctMsg=[];
                    res.data.data.xxzxList.forEach(element => {
                        var t=new Date(this.$moment(element.xxsj).format("YYYY/MM/DD HH:mm:ss"))
                        var h=t.getHours()<10?'0'+t.getHours():t.getHours();
                        var m=t.getMinutes()<10?'0'+t.getMinutes():t.getMinutes();
                        var s=t.getSeconds()<10?'0'+t.getSeconds():t.getSeconds();
                        let obj={
                            mc:element.tbdwmc+'【'+h+':'+m+':'+s+'】：',
                            msg:element.xxnr
                        }
                        this.sokctMsg.push(obj)
                    });
                    this.$nextTick(()=>{
                        if(document.getElementById('msg')){
                            document.getElementById('msg').scrollTop = document.getElementById('msg').scrollHeight+10;
                        }
                    })
                    // 判断是否开启摄像头
                    this.sfkqsxt = res.data.data.sfkqsxt
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
            }).catch(()=>{})
        },
        websockMessage(e){
            var obj=JSON.parse(e)
            if(obj.msg=='closeFy'){
                this.flag=true
            }else if(obj.msg=='openFy'){
                this.flag=false
            }else{
                this.$set(this.sokctMsg, this.sokctMsg.length, obj)
                this.$nextTick(()=>{
                    if(document.getElementById('msg')){
                        document.getElementById('msg').scrollTop = document.getElementById('msg').scrollHeight+10;
                    }
                    
                })
            }
        },
        //发送
        send(){
            if(this.msg.trim()){
                let para={
                    userName:localStorage.getItem('user'),
                    xxnr:this.msg.trim()
                }
                this.$api.sendXx(para).then(res=>{
                    if(res.data.meta.success){
                        var t=new Date(this.$moment(res.data.data.xxzx.xxsj).format("YYYY/MM/DD HH:mm:ss"))
                        var h=t.getHours()<10?'0'+t.getHours():String(t.getHours());
                        var m=t.getMinutes()<10?'0'+t.getMinutes():String(t.getMinutes());
                        var s=t.getSeconds()<10?'0'+t.getSeconds():String(t.getSeconds());
                        let obj={
                            lx:'msg',
                            data:{
                                mc:res.data.data.xxzx.tbdwmc+'【'+h+':'+m+':'+s+'】：',
                                msg:res.data.data.xxzx.xxnr
                            }
                        }
                        this.$emit('send',JSON.stringify(obj))
                        this.msg=''
                    }else{
                        this.$message({
                            type:'error',
                            message:res.data.meta.message
                        })
                    }
                }).catch(()=>{})
            }else{
                this.$message({
                    type:'warning',
                    message:'发送内容不能为空，请重新输入。'
                })
            }
            
        },
        close(){
            let para;
            if(this.flag){
                para={
                    kqfy:'1'
                }
            }else{
                para={
                    kqfy:'0'
                }
            }
            this.$api.kqfy(para).then(res=>{
                if(res.data.meta.success){
                    var msg=''
                    if(this.flag){
                        msg='openFy'
                    }else{
                        msg='closeFy'
                    }
                    let obj={
                        lx:'msg',
                        data:{
                            msg:msg
                        }
                    }
                    this.$emit('send',JSON.stringify(obj))
                }
            }).catch(()=>{})
        },
        //打开更多消息
        moreMsg(){
            let para={}
            this.xxzxDialog=true;
            this.$api.getMoreMsg(para).then(res=>{
                if(res.data.meta.success){
                    this.xxzxList=res.data.data.list
                }
            }).catch(()=>{})
        },
        sjFormatter(row,column,callback,index){
            if(row.sj){
                return this.$moment(row.sj).format("YYYY-MM-DD HH:mm:ss");
            }else{
                return this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
            }
        }
    },
    mounted(){
        this.getMsg();
    },
    destroyed(){
    }

}
</script>
<style lang="less">
    .msgCenter{
        background:@warning-color;
        color:#666;
        padding:5px;
        border-radius: 3px;
        height:calc(~"100% - 335px");
        .msgTitle{
            height:35px;
            line-height: 35px;
            color:#fff;
            p.lf{
                font-size: 16px;
                font-weight: bold;
            }
            p.rt{
                cursor: pointer;
            }
        }
        .msgs{
            background:#fff;
            border-radius: 3px;
            margin-bottom:10px;
            position: relative;
            height: calc(~"100% - 85px");
            .xtMsg{
                border-bottom:1px solid @warning-color;
                padding:10px 10px 0 10px;
                h3{
                    color:@warning-color;
                    background:url('../assets/images/msg.jpg') no-repeat left center;
                    padding-left:30px;
                    height:28px;
                    line-height:28px;
                }
                div{
                    line-height:20px;
                    padding-left:30px;
                    overflow: hidden;
                    height:40px;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .activeStep{
                    color:@base-color;
                    line-height:35px;
                    span{
                        font-weight: bold;
                    }
                    padding-left:30px;
                }
                .nextStep{
                    color:@warning-color;
                    line-height:35px;
                    padding-left:30px;
                }
            }
            .msg{
                min-height:150px;
                overflow-y: auto;
                padding:10px 20px 10px 40px;
                line-height:24px;
                height:calc(~"100% - 80px");
                .dwmc{
                    color:@base-color;
                }
                >div{
                    word-break: break-all;
                }
            }
            .closeMsg{
                position: absolute;
                top:85px;
                left:5px;
                background: #333;
                color:#fff;
                width:20px;
                height: 60px;
                line-height:14px;
                border-radius: 3px;
                padding:2px 4px;
                font-size: 12px;
                cursor: pointer;
            }
        }
        .msgText{
            display: flex;
            align-items: center;
            justify-content: center;
            .el-input{
                width:365px;
                margin-right:10px;
            }
            button{
                min-width:73px;
                line-height:40px;
                height:40px;
                background: #fff;
                color: #f39800;
                font-weight: bold;
                &:hover{
                    background: #fff;
                }
            }
            
        }
    }
</style>